import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { PayrollItem } from './store';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { IGenericResponse } from '../../shared';
import { LoadingService } from '../../shared/loading/loading-service.service';
import { PayrollItemEmployee } from './store/payroll-item-employee.model';
import * as fromRoot from '../../store';
@Injectable({
    providedIn: 'root'
})
export class PayrollItemService extends LoadingService {
    private uri = `${environment.apiLocation}/PayrollItemSetting`;
    private uriPayrollItemEmployee = `${environment.apiLocation}/PayrollItemEmployee`;

    constructor(
        private http: HttpClient,
        protected log: LoggingService,
        protected rootStore: Store<fromRoot.CoreState>
    ) {
        super(rootStore);
    }

    public get(activeOnly: boolean = true): Observable<PayrollItem[]> {
        super.Load();
        const params = { activeonly: String(activeOnly) };
        return this.http.get<PayrollItem[]>(this.uri, { params }).pipe(
            tap(data => {
                super.Stop();
                this.log.verbose({
                    type: 'PayrollItemService:get',
                    data
                });
            }),
            map(pi => pi.map(x => ({ ...x, id: this.getPayrollItemId(x) })))
        );
    }
    public put(items): Observable<IGenericResponse<PayrollItem>> {
        return this.http
            .put<IGenericResponse<PayrollItem>>(this.uri, {
                PayrollItemSettingList: items
            })
            .pipe(
                tap(data =>
                    this.log.verbose({
                        type: 'PayrollItemService:put',
                        data
                    })
                ),
                map(pi => ({
                    ...pi,
                    Items: pi.Items.map(x => ({
                        ...x,
                        id: this.getPayrollItemId(x)
                    }))
                }))
            );
    }
    public getEmployees(
        Payrollitemlistid: string
    ): Observable<PayrollItemEmployee[]> {
        super.Load();
        return this.http
            .get<PayrollItemEmployee[]>(
                `${this.uriPayrollItemEmployee}?Payrollitemlistid=${Payrollitemlistid}`
            )
            .pipe(
                tap(data => {
                    super.Stop();
                    this.log.verbose({
                        type: 'PayrollItemService:getEmployees',
                        data
                    });
                }),
                map(rates =>
                    rates.map(x => ({
                        ...x,
                        Status: x.Status || {
                            StatusCode: null,
                            Message: null
                        },
                        id: this.getPayrollItemEmployeeId(x)
                    }))
                )
            );
    }

    private getPayrollItemEmployeeId(item: PayrollItemEmployee) {
        return item.Employeelistid;
    }

    private getPayrollItemId(item: PayrollItem) {
        return item.PIListID;
    }
}
